<template>
    <master-layout>

        <!-- Breadcamb -->
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title"><i class="ti-bar-chart"></i> {{ $t('sources_report') }}</h4>
            </div>
            <pml-back-button></pml-back-button>
        </div>

        <div class="card-box">
            <form @submit.prevent="doFilter()">
                <div class="row">
                    <div class="col-xs-12 col-md-6 m-b-15 clearfix" :class="{'has-error': errors['date_from'], 'has-error': errors['date_to']}">
                        <label>{{ $t('created_at') }}</label>
                        <div class="input-daterange input-group">
                            <pml-date-picker v-model="filter.date_from"></pml-date-picker>
                            <span class="input-group-addon b-0"><i class="fa fa-calendar"></i></span>
                            <pml-date-picker v-model="filter.date_to"></pml-date-picker>
                        </div>
                        <span class="error" v-if="errors['date_from']">{{ errors['date_from'][0] }}</span>
                        <span class="error" v-if="errors['date_to']">{{ errors['date_to'][0] }}</span>
                    </div>
                    <div class="col-xs-12 col-md-6 m-b-15 clearfix" :class="{'has-error': errors['member_id']}">
                        <label>{{ $t('consultant') }}</label>
                        <pml-select-members v-model="filter.member_id" :onlyActive="true"></pml-select-members>
                        <span class="error" v-if="errors['member_id']">{{ errors['member_id'][0] }}</span>
                    </div>
                    <div class="col-xs-12 col-md-6 m-b-15 clearfix" :class="{'has-error': errors['source_id']}">
                        <label>{{ $t('source') }}</label>
                        <pml-select v-model="filter.source_id" :options="sources"></pml-select>
                        <span class="error" v-if="errors['source_id']">{{ errors['source_id'][0] }}</span>
                    </div>
                    <div class="col-xs-12 col-md-6 m-b-15 clearfix" :class="{'has-error': errors['source_id']}">
                        <label>{{ $t('segments') }}</label>
                        <pml-select v-model="filter.segment_id" :options="segments"></pml-select>
                        <span class="error" v-if="errors['source_id']">{{ errors['source_id'][0] }}</span>
                    </div>
                </div>
                <hr class="m-t-0">
                <div class="clearfix">
                    <span class="btn btn-white pull-left" @click.prevent="clear"><i class="fa fa-paint-brush m-r-5"></i> {{ $t('clear') }}</span>
                    <button class="btn btn_green pull-right" type="submit" v-pml-block="isLoading">
                        <span class="btn-label">
                            <i class="fa fa-search"></i>
                        </span>
                        {{ $t('filter') }}
                    </button>
                </div>
            </form>
        </div>

        <PmlRealTime :is-loading="isLoading" :chart-data="realTime"></PmlRealTime>

        <PmlOverview :is-loading="isLoading" :chart-data="overview"></PmlOverview>

        <PmlByConsultant :is-loading="isLoading" :table-data="byConsultant"></PmlByConsultant>
    </master-layout>
</template>

<script>
    import PmlRealTime from './RealTime.vue'
    import PmlOverview from './Overview.vue'
    import PmlByConsultant from './ByConsultant.vue'
    import moment from 'moment'
    import { getSourcesReport } from 'services/reports'
    import { trans } from 'utils/helpers/translation'
    import { mapGetters } from 'vuex'

    export default {
        name: 'SourcesReport',
        components: { PmlRealTime, PmlOverview, PmlByConsultant },
        data () {
            return {
                realTime: false,
                overview: false,
                byConsultant: false,
                filter: {
                    date_from: null,
                    date_to: null,
                    member_id: null,
                    source_id: null,
                    segment_id: null
                },
                isLoading: false,
                errors: []
            }
        },
        computed: {
            ...mapGetters({
                sources: 'getSources',
                segments: 'getSegments'
            })
        },
        metaInfo () {
            return {
                title: trans('sources_report')
            }
        },
        mounted () {
            this.clear()
            this.doFilter()
        },
        methods: {
            clear () {
                this.filter.date_from = moment().subtract(14, 'days').format('DD/MM/YYYY')
                this.filter.date_to = moment().add(1, 'days').format('DD/MM/YYYY')
                this.filter.member_id = null
                this.filter.source_id = null
                this.filter.segment_id = null
                this.errors = []
            },
            doFilter () {
                this.isLoading = true

                getSourcesReport(this.filter)
                    .then(response => {
                        this.realTime = response.data.real_time
                        this.overview = response.data.overview
                        this.byConsultant = response.data.byConsultant
                        this.errors = []
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isLoading = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/sources/components/Main.vue